// extracted by mini-css-extract-plugin
export default {"weirBackground":"main_weirBackground__JsAsX","layer":"main_layer__n4DSm","wrapper":"main_wrapper__FggCT","loginContentAccess":"main_loginContentAccess__ojeuP"};